import { DateTime } from 'luxon'

import { RadioResponseDTO } from '@core/api/dtos/response/radio/radio'
import { Radio } from '@core/api/entities/radio/radio'

import { SegmentMapper } from './segmentMapper'

export class RadioMapper {
	static toEntity(data: RadioResponseDTO): Radio {
		let createdAt = DateTime.fromISO(data.created_at)
		if (!createdAt.isValid) {
			createdAt = DateTime.fromFormat(data.created_at, 'yyyy-MM-dd HH:mm:ss')
		}
		let updatedAt = DateTime.fromISO(data.updated_at)
		if (!updatedAt.isValid) {
			updatedAt = DateTime.fromFormat(data.updated_at, 'yyyy-MM-dd HH:mm:ss')
		}

		return new Radio({
			id: data.id,
			title: data.title,
			titleTranslations: data.title_translations,
			description: data.description,
			descriptionTranslations: data.description_translations,
			categories: data.categories,
			genres: data.genres,
			businessCategoriesIds: data.business_categories_ids,
			cover: data.cover,
			thumbs: data.thumbs,
			public: data.public,
			type: data.type,
			rotateAutomatically: data.rotate_automatically,
			rotationPercentage: data.rotation_percentage,
			rotationPeriodAmount: data.rotation_period_amount,
			rotationPeriodType: data.rotation_period_type,
			nextRotationDate: DateTime.fromISO(data.next_rotation_date),
			metadata: data.metadata?.mix
				? {
						id: data.metadata.mix.id,
						mixID: data.metadata.mix.mix_id,
						mixPercentage: data.metadata.mix.mix_percentage,
						isDefault: data.metadata.mix.is_default,
						rrule: data.metadata.mix.rrule,
					}
				: undefined,
			createdAt,
			updatedAt,

			segments: data.segments?.data
				? SegmentMapper.toEntities(data.segments.data)
				: [],
		})
	}

	static toEntities(data: RadioResponseDTO[]): Radio[] {
		return data.map((radio) => this.toEntity(radio))
	}
}
